export default [
  {
    key: 'cvilux',
    coverImage: '/assets/img/projects/cvilux/1.webp',
    titleKey: 'projects.gallery.cvilux.title',
    altKey: 'projects.gallery.cvilux.alt',
    bodyKey: 'projects.gallery.cvilux.body',
    imageOnLeft: false,
    images: [
      '/assets/img/projects/cvilux/2.webp',
      '/assets/img/projects/cvilux/3.webp',
      '/assets/img/projects/cvilux/4.webp',
      '/assets/img/projects/cvilux/5.webp',
      '/assets/img/projects/cvilux/6.webp',
      '/assets/img/projects/cvilux/7.webp',
      '/assets/img/projects/cvilux/8.webp',
      '/assets/img/projects/cvilux/9.webp',
      '/assets/img/projects/cvilux/10.webp',
      '/assets/img/projects/cvilux/11.webp',
      '/assets/img/projects/cvilux/12.webp',
      '/assets/img/projects/cvilux/13.webp',
      '/assets/img/projects/cvilux/14.webp',
      '/assets/img/projects/cvilux/15.webp',
      '/assets/img/projects/cvilux/16.webp',
      '/assets/img/projects/cvilux/17.webp',
      '/assets/img/projects/cvilux/18.webp',
      '/assets/img/projects/cvilux/19.webp',
      '/assets/img/projects/cvilux/20.webp',
      '/assets/img/projects/cvilux/21.webp',
      '/assets/img/projects/cvilux/22.webp',
      '/assets/img/projects/cvilux/23.webp',
      '/assets/img/projects/cvilux/24.webp',
      '/assets/img/projects/cvilux/25.webp',
      '/assets/img/projects/cvilux/26.webp',
      '/assets/img/projects/cvilux/27.webp',
      '/assets/img/projects/cvilux/28.webp',
      '/assets/img/projects/cvilux/29.webp',
      '/assets/img/projects/cvilux/30.webp',
      '/assets/img/projects/cvilux/31.webp',
      '/assets/img/projects/cvilux/32.webp',
      '/assets/img/projects/cvilux/33.webp',
      '/assets/img/projects/cvilux/34.webp',
      '/assets/img/projects/cvilux/35.webp',
      '/assets/img/projects/cvilux/36.webp',
      '/assets/img/projects/cvilux/37.webp',
      '/assets/img/projects/cvilux/38.webp',
      '/assets/img/projects/cvilux/39.webp',
      '/assets/img/projects/cvilux/40.webp',
      '/assets/img/projects/cvilux/41.webp',
    ],
  },
  {
    key: 'herbalshake',
    coverImage: '/assets/img/projects/herbalshake/1.webp',
    titleKey: 'projects.gallery.herbalshake.title',
    altKey: 'projects.gallery.herbalshake.alt',
    bodyKey: 'projects.gallery.herbalshake.body',
    imageOnLeft: true,
    images: [
      '/assets/img/projects/herbalshake/2.webp',
      '/assets/img/projects/herbalshake/3.webp',
      '/assets/img/projects/herbalshake/4.webp',
      '/assets/img/projects/herbalshake/5.webp',
      '/assets/img/projects/herbalshake/6.webp',
      '/assets/img/projects/herbalshake/7.webp',
      '/assets/img/projects/herbalshake/8.webp',
      '/assets/img/projects/herbalshake/9.webp',
      '/assets/img/projects/herbalshake/10.webp',
      '/assets/img/projects/herbalshake/11.webp',
      '/assets/img/projects/herbalshake/12.webp',
      '/assets/img/projects/herbalshake/13.webp',
      '/assets/img/projects/herbalshake/14.webp',
      '/assets/img/projects/herbalshake/15.webp',
      '/assets/img/projects/herbalshake/16.webp',
      '/assets/img/projects/herbalshake/18.webp',
      '/assets/img/projects/herbalshake/19.webp',
    ],
  },
  {
    key: 'ezmaster',
    coverImage: '/assets/img/projects/ezmaster/1.webp',
    titleKey: 'projects.gallery.ezmaster.title',
    altKey: 'projects.gallery.ezmaster.alt',
    bodyKey: 'projects.gallery.ezmaster.body',
    imageOnLeft: false,
    images: [
      '/assets/img/projects/ezmaster/3.webp',
      '/assets/img/projects/ezmaster/4.webp',
      '/assets/img/projects/ezmaster/5.webp',
      '/assets/img/projects/ezmaster/6.webp',
      '/assets/img/projects/ezmaster/7.webp',
      '/assets/img/projects/ezmaster/8.webp',
      '/assets/img/projects/ezmaster/9.webp',
      '/assets/img/projects/ezmaster/10.webp',
      '/assets/img/projects/ezmaster/11.webp',
      '/assets/img/projects/ezmaster/12.webp',
      '/assets/img/projects/ezmaster/13.webp',
      '/assets/img/projects/ezmaster/14.webp',
      '/assets/img/projects/ezmaster/15.webp',
      '/assets/img/projects/ezmaster/16.webp',
      '/assets/img/projects/ezmaster/17.webp',
    ],
  },
  {
    key: 'transportation',
    coverImage: '/assets/img/projects/transportation/1.webp',
    titleKey: 'projects.gallery.transportation.title',
    altKey: 'projects.gallery.transportation.alt',
    bodyKey: 'projects.gallery.transportation.body',
    imageOnLeft: true,
    images: [
      '/assets/img/projects/transportation/2.webp',
      '/assets/img/projects/transportation/3.webp',
      '/assets/img/projects/transportation/4.webp',
      '/assets/img/projects/transportation/5.webp',
      '/assets/img/projects/transportation/6.webp',
    ],
  },
  {
    key: 'rdm',
    coverImage: '/assets/img/projects/rdm/1.webp',
    titleKey: 'projects.gallery.rdm.title',
    altKey: 'projects.gallery.rdm.alt',
    bodyKey: 'projects.gallery.rdm.body',
    imageOnLeft: false,
    images: [
      '/assets/img/projects/rdm/2.webp',
      '/assets/img/projects/rdm/3.webp',
      '/assets/img/projects/rdm/4.webp',
      '/assets/img/projects/rdm/5.webp',
      '/assets/img/projects/rdm/6.webp',
      '/assets/img/projects/rdm/7.webp',
      '/assets/img/projects/rdm/8.webp',
      '/assets/img/projects/rdm/9.webp',
    ],
  },
  {
    key: 'petid',
    coverImage: '/assets/img/projects/petid/1.webp',
    titleKey: 'projects.gallery.petid.title',
    altKey: 'projects.gallery.petid.alt',
    bodyKey: 'projects.gallery.petid.body',
    imageOnLeft: true,
    images: [
      '/assets/img/projects/petid/2.webp',
      '/assets/img/projects/petid/3.webp',
      '/assets/img/projects/petid/4.webp',
      '/assets/img/projects/petid/5.webp',
      '/assets/img/projects/petid/6.webp',
      '/assets/img/projects/petid/7.webp',
      '/assets/img/projects/petid/8.webp',
      '/assets/img/projects/petid/9.webp',
      '/assets/img/projects/petid/24.webp',
      '/assets/img/projects/petid/10.webp',
      '/assets/img/projects/petid/11.webp',
      '/assets/img/projects/petid/12.webp',
      '/assets/img/projects/petid/13.webp',
      '/assets/img/projects/petid/14.webp',
      '/assets/img/projects/petid/15.webp',
      '/assets/img/projects/petid/16.webp',
      '/assets/img/projects/petid/18.webp',
      '/assets/img/projects/petid/19.webp',
      '/assets/img/projects/petid/20.webp',
      '/assets/img/projects/petid/25.webp',
      '/assets/img/projects/petid/26.webp',
      '/assets/img/projects/petid/27.webp',
      '/assets/img/projects/petid/21.webp',
      '/assets/img/projects/petid/22.webp',
      '/assets/img/projects/petid/23.webp',
      '/assets/img/projects/petid/29.webp',
      '/assets/img/projects/petid/30.webp',
      '/assets/img/projects/petid/31.webp',
      '/assets/img/projects/petid/32.webp',
      '/assets/img/projects/petid/33.webp',
      '/assets/img/projects/petid/28.webp',
    ],
  },
  {
    key: 'pi2',
    coverImage: '/assets/img/projects/pi2/1.webp',
    titleKey: 'projects.gallery.pi2.title',
    altKey: 'projects.gallery.pi2.alt',
    bodyKey: 'projects.gallery.pi2.body',
    imageOnLeft: false,
    images: [
      '/assets/img/projects/pi2/13.webp',
      '/assets/img/projects/pi2/14.webp',
      '/assets/img/projects/pi2/15.webp',
      '/assets/img/projects/pi2/16.webp',
      '/assets/img/projects/pi2/17.webp',
      '/assets/img/projects/pi2/18.webp',
      '/assets/img/projects/pi2/19.webp',
      '/assets/img/projects/pi2/20.webp',
      '/assets/img/projects/pi2/21.webp',
      '/assets/img/projects/pi2/22.webp',
      '/assets/img/projects/pi2/23.webp',
      '/assets/img/projects/pi2/3.webp',
      '/assets/img/projects/pi2/4.webp',
      '/assets/img/projects/pi2/5.webp',
      '/assets/img/projects/pi2/6.webp',
      '/assets/img/projects/pi2/7.webp',
      '/assets/img/projects/pi2/8.webp',
      '/assets/img/projects/pi2/9.webp',
      '/assets/img/projects/pi2/10.webp',
      '/assets/img/projects/pi2/11.webp',
      '/assets/img/projects/pi2/12.webp',
    ],
  },
  {
    key: 'edm',
    coverImage: '/assets/img/projects/edm/1.webp',
    titleKey: 'projects.gallery.edm.title',
    altKey: 'projects.gallery.edm.alt',
    bodyKey: 'projects.gallery.edm.body',
    imageOnLeft: true,
    images: [
      '/assets/img/projects/edm/2.webp',
      '/assets/img/projects/edm/3.webp',
      '/assets/img/projects/edm/8.webp',
      '/assets/img/projects/edm/4.webp',
      '/assets/img/projects/edm/5.webp',
      '/assets/img/projects/edm/6.webp',
      '/assets/img/projects/edm/7.webp',
      '/assets/img/projects/edm/9.webp',
    ],
  },
  {
    key: 'tte2014',
    coverImage: '/assets/img/projects/tte2014/1.webp',
    titleKey: 'projects.gallery.tte2014.title',
    altKey: 'projects.gallery.tte2014.alt',
    bodyKey: 'projects.gallery.tte2014.body',
    imageOnLeft: false,
    images: [
      '/assets/img/projects/tte2014/3.webp',
      '/assets/img/projects/tte2014/4.webp',
      '/assets/img/projects/tte2014/5.webp',
      '/assets/img/projects/tte2014/6.webp',
      '/assets/img/projects/tte2014/7.webp',
      '/assets/img/projects/tte2014/8.webp',
      '/assets/img/projects/tte2014/9.webp',
      '/assets/img/projects/tte2014/10.webp',
      '/assets/img/projects/tte2014/11.webp',
      '/assets/img/projects/tte2014/12.webp',
      '/assets/img/projects/tte2014/13.webp',
      '/assets/img/projects/tte2014/14.webp',
      '/assets/img/projects/tte2014/15.webp',
      '/assets/img/projects/tte2014/16.webp',
      '/assets/img/projects/tte2014/17.webp',
    ],
  },
  {
    key: 'kaley',
    coverImage: '/assets/img/projects/kaley/6.webp',
    titleKey: 'projects.gallery.kaley.title',
    altKey: 'projects.gallery.kaley.alt',
    bodyKey: 'projects.gallery.kaley.body',
    imageOnLeft: true,
    images: [
      '/assets/img/projects/kaley/7.webp',
      '/assets/img/projects/kaley/8.webp',
      '/assets/img/projects/kaley/9.webp',
      '/assets/img/projects/kaley/10.webp',
      '/assets/img/projects/kaley/1.webp',
      '/assets/img/projects/kaley/2.webp',
      '/assets/img/projects/kaley/3.webp',
      '/assets/img/projects/kaley/4.webp',
      '/assets/img/projects/kaley/5.webp',
    ],
  },
  {
    key: 'greenewera',
    coverImage: '/assets/img/projects/greenewera/1.webp',
    titleKey: 'projects.gallery.greenewera.title',
    altKey: 'projects.gallery.greenewera.alt',
    bodyKey: 'projects.gallery.greenewera.body',
    imageOnLeft: false,
    images: [
      '/assets/img/projects/greenewera/2.webp',
      '/assets/img/projects/greenewera/3.webp',
      '/assets/img/projects/greenewera/4.webp',
      '/assets/img/projects/greenewera/5.webp',
      '/assets/img/projects/greenewera/6.webp',
      '/assets/img/projects/greenewera/7.webp',
      '/assets/img/projects/greenewera/8.webp',
      '/assets/img/projects/greenewera/9.webp',
      '/assets/img/projects/greenewera/10.webp',
      '/assets/img/projects/greenewera/mobile-1.webp',
      '/assets/img/projects/greenewera/mobile-2.webp',
      '/assets/img/projects/greenewera/mobile-3.webp',
      '/assets/img/projects/greenewera/mobile-4.webp',
      '/assets/img/projects/greenewera/mobile-5.webp',
    ],
  },
]
